import useCompanyContext from 'common/hooks/useCompanyContext';
import useErrorHandledMutation from 'common/hooks/useErrorHandledMutation';

import { refetchQueryDirectDebitMandateCounts } from '../useDirectDebitMandateCountsQuery';
import { refetchQueryDirectDebitMandates } from '../useDirectDebitMandatesQuery';
import { RevokeDirectDebitMandateDocument } from './revokeDirectDebitMandate.gql';

interface RevokeDirectDebitMandateVariables {
  input: {
    directDebitMandateId: string;
  };
}

interface RevokeDirectDebitMandateResponse {
  directDebitMandate: {
    directDebitMandateId: string;
    isRevoked: boolean;
    revokedAt: string;
  };
}

export function useRevokeDirectDebitMandateMutation(
  directDebitMandateId: string,
) {
  const { companyProfileId } = useCompanyContext();
  if (!companyProfileId) {
    throw new Error(
      'companyProfileId is required in useRevokeDirectDebitMandateMutation',
    );
  }

  return useErrorHandledMutation<
    RevokeDirectDebitMandateResponse,
    RevokeDirectDebitMandateVariables
  >(RevokeDirectDebitMandateDocument, {
    awaitRefetchQueries: true,
    refetchQueries: [
      refetchQueryDirectDebitMandates({ companyProfileId, isRevoked: true }),
      refetchQueryDirectDebitMandates({ companyProfileId, isRevoked: false }),
      refetchQueryDirectDebitMandateCounts({ companyProfileId }),
    ],
    variables: {
      input: {
        directDebitMandateId,
      },
    },
  });
}
